import orderListCache from './orderList'
export default orderListCache



// WEBPACK FOOTER //
// ./pagesCache/orderList/index.js